"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _common = require("../@api/common");
var _store = require("../@api/store");
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["items", "label", "rightIcon", "preventCloseOnBlur", "getComparisonText", "renderItem"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/// GROUP CHAT based on appcenter groups

var Autocomplete = function Autocomplete(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    label = _ref.label,
    rightIcon = _ref.rightIcon,
    preventCloseOnBlur = _ref.preventCloseOnBlur,
    _ref$getComparisonTex = _ref.getComparisonText,
    getComparisonText = _ref$getComparisonTex === void 0 ? function (o) {
      JSON.stringify(o);
    } : _ref$getComparisonTex,
    _ref$renderItem = _ref.renderItem,
    renderItem = _ref$renderItem === void 0 ? function (o) {
      return o;
    } : _ref$renderItem,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0,
      width: 0
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    windowVisible = _useState6[0],
    setWindowVisibilty = _useState6[1];
  var mainRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: mainRef,
    className: "zero-autocomplete ".concat(rest.className || '')
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    label: label,
    mode: "outlined",
    rightIcon: rightIcon || 'faCaretDown',
    rightIconClick: function rightIconClick(e) {
      setWindowVisibilty(!windowVisible);
    }
  }, rest, {
    onChange: function onChange(e) {
      if (typeof rest.onChange === 'function') rest.onChange(e);
      setSearchText(e.target.value);
    },
    onFocus: function onFocus(e) {
      setWindowVisibilty(true);
      setTimeout(function () {
        var rect = mainRef.current.getBoundingClientRect();
        setPosition({
          top: mainRef.current.offsetTop,
          left: rect.left,
          width: rect.width
        });
      }, 0);
    },
    onBlur: function onBlur(e) {
      if (preventCloseOnBlur) return;
      setWindowVisibilty(false);
    }
  })), windowVisible && !!searchText.length && /*#__PURE__*/_react["default"].createElement("div", {
    className: "zero-autocomplete-items-window",
    style: _objectSpread({}, position)
  }, items.filter(function (o) {
    if (!searchText) return true;
    return getComparisonText(o).toLowerCase().indexOf(searchText.toLowerCase()) > -1;
  }).map(function (item) {
    return renderItem(item) || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  })));
};
var _default = Autocomplete;
exports["default"] = _default;